import { render, staticRenderFns } from "./SvgProgramIntroWeb.vue?vue&type=template&id=01cbe32e&scoped=true"
import script from "./SvgProgramIntroWeb.vue?vue&type=script&lang=js"
export * from "./SvgProgramIntroWeb.vue?vue&type=script&lang=js"
import style0 from "./SvgProgramIntroWeb.vue?vue&type=style&index=0&id=01cbe32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cbe32e",
  null
  
)

export default component.exports